import * as LDClient from "launchdarkly-js-client-sdk";

export const sessionInspector: LDClient.LDInspection = {
  type: "flag-used",
  name: "session-inspector",
  method: (key: string, detail: LDClient.LDEvaluationDetail) => {
    sessionStorage.setItem(`ldFlag:${key}`, JSON.stringify(detail.value));
  },
};
